<template>
  <div>
    <Header
      v-if="!this.$store.getters.iframeColidee"
      :window="window"
      :parameters="'adminPage'"
    />
    <div
      style="padding-top:10px;"
      :class="
        !this.$store.getters.iframeColidee
          ? window.width < 480
            ? 'container-fluid'
            : 'container'
          : null
      "
    >
      <ButtonReturnColidee
        v-if="
          this.$store.getters.iframeColidee && adminActiveComponents.parameters
        "
        :adminComponent="true"
      />
      <SearchBar v-if="adminActiveComponents.searchBar" />
      <CardsList :window="window" v-if="adminActiveComponents.cardList" />
      <Parameters v-if="adminActiveComponents.parameters" />
    </div>
    <br /><br /><br />
    <Footer v-if="!this.$store.getters.iframeColidee" :window="window" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "@/components/layout/Header";
import CardsList from "@/components/event/CardsList";
import Parameters from "@/components/event/Parameters";
import SearchBar from "@/components/event/components/SearchBar";
import Footer from "@/components/layout/Footer";

export default {
  components: {
    Header,
    SearchBar,
    Parameters,
    Footer,
    CardsList
  },
  data() {
    return {
      window: {
        width: window.innerWidth
      }
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
    }
  },
  computed: {
    ...mapGetters(["adminActiveComponents"])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/page/Admin.vue